import { DEFAULT_LOCATION_LABEL, isLocationMessage, parseLocationMessage } from './locationUtils';

const PRESET_TYPES = new Set(['template', 'li_preset', 'cr_preset']);

export const resolveReplyWamid = (message) => {
  if (!message) {
    return null;
  }

  const candidates = [message.message_id, message.status_id].filter(Boolean);
  for (const value of candidates) {
    const str = String(value);
    if (str.startsWith('wamid.')) {
      return str;
    }
  }

  return null;
};

export const buildReplyPreviewText = (message) => {
  if (!message) {
    return '';
  }

  const type = String(message.msgType || message.type || 'text').toLowerCase();

  if (type === 'location' || isLocationMessage(message)) {
    return parseLocationMessage(message)?.label || DEFAULT_LOCATION_LABEL;
  }

  if (type === 'image' || type === 'sticker') {
    const caption = String(message.caption || '').trim();
    return caption || 'Photo';
  }

  if (type === 'video') {
    const caption = String(message.caption || '').trim();
    return caption || 'Video';
  }

  if (type === 'audio') {
    return 'Audio';
  }

  if (type === 'document') {
    return message.file_name || 'Document';
  }

  if (PRESET_TYPES.has(type)) {
    return message.preset_name || message.text || 'Template';
  }

  return String(message.text || '').trim();
};

export const buildReplyToFromMessage = (message) => {
  if (!message) {
    return null;
  }

  const type = String(message.msgType || message.type || 'text').toLowerCase();
  const text = buildReplyPreviewText(message);

  if (!text) {
    return null;
  }

  return {
    id: message.id ?? null,
    message_id: resolveReplyWamid(message),
    from: message.from || 'opposite',
    type,
    msgType: type,
    text,
    media_url: message.media_url || null,
    file_name: message.file_name || null,
  };
};
